import {
	Avatar,
	Button,
	Flex,
	Icon,
	Menu,
	MenuItem,
	MenuTrigger,
	Popover,
	Text,
} from "@repo/ui";
import { useQuery } from "../db/DatabaseProvider";
import { TaskId, UserId } from "../db/schema";

type AssigneePickerProps = {
	assignedTo: UserId | undefined;
	assigneeType?: "user" | "agent";
	taskId: TaskId;
	onChange?: (
		assignedTo: UserId | undefined,
		assigneeType?: "user" | "agent",
	) => void;
};

export function AssigneePicker({
	assignedTo,
	assigneeType: _assigneeType,
	taskId: _taskId,
	onChange,
}: AssigneePickerProps) {
	const users = useQuery("user", (q) => q, []);
	const assignedUser = users.find((user) => user.id === assignedTo);

	return (
		<MenuTrigger>
			<Button variant="ghost" size="sm">
				<Flex
					gap="xs"
					align="center"
					borderRadius="md"
					style={{ minHeight: 20, width: "100%" }}
				>
					{assignedUser ? (
						<>
							<Avatar
								size="sm"
								image={assignedUser.imageUrl}
								name={assignedUser.name}
							/>
							<Text size="sm" weight="medium" style={{ userSelect: "none" }}>
								{assignedUser.name}
							</Text>
						</>
					) : (
						<>
							<Flex align="center" justify="center" padding="xxs">
								<Icon name="CircleUser" color="sand11" size="sm" />
							</Flex>
							<Text size="sm" weight="medium" style={{ userSelect: "none" }}>
								Unassigned
							</Text>
						</>
					)}
				</Flex>
			</Button>
			<Popover placement="bottom start">
				<Menu>
					<MenuItem onAction={() => onChange?.(undefined, "user")}>
						<Flex gap="xs" flex align="center">
							<Flex align="center" justify="center" padding="xxs">
								<Icon name="CircleUser" color="sand11" size="sm" />
							</Flex>
							<Text size="sm" weight="medium" style={{ userSelect: "none" }}>
								Unassigned
							</Text>
						</Flex>
						{!assignedTo && <Icon name="Check" color="accent9" size="sm" />}
					</MenuItem>
					{users.map((user) => (
						<MenuItem
							key={user.id}
							onAction={() => onChange?.(user.id, "user")}
						>
							<Flex gap="xs" flex align="center">
								<Avatar size="sm" image={user.imageUrl} name={user.name} />
								<Text size="sm" weight="medium" style={{ userSelect: "none" }}>
									{user.name}
								</Text>
							</Flex>
							{assignedTo === user.id && (
								<Icon name="Check" color="accent9" size="sm" />
							)}
						</MenuItem>
					))}
				</Menu>
			</Popover>
		</MenuTrigger>
	);
}
